<template>
    <div>
        <v-tooltip bottom
        >
            <template v-slot:activator="{ on: tooltip }">
                <v-btn
                    
                    class="mr-1"
                    small
                    color="primary"
                    dark v-on="{...tooltip}"
                    v-on:click="() => dialog = !dialog"
                >
                    <v-icon>mdi-pin</v-icon>
                </v-btn>
            </template>
            <span>{{ $t('referenceBooks.branches.PinBranch') + ' ' + $t('toNormal')}}</span>
        </v-tooltip>
        <DragForm
            v-model="dialog"
        >
            <v-card  width="800">
                <v-card-title>
                    <span class="headline">{{ $t('referenceBooks.branches.PinBranch') + `(${branch.name}) ` + $t('toNormal')}}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>

                            <v-col cols="12" sm="12" md="12">
                                {{ $t('referenceBooks.branches.PinBranch')}} {{$t('toNormal')}}
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <v-autocomplete
                                        :label="$t('referenceBooks.branches.AvailableToPinBranches')"
                                        v-model="selectedBranches"
                                        :key="'branchId'"
                                        :item-value="'branchId'"
                                        :item-text="'name'"
                                        :items="branches"
                                        required
                                        return-object
                                />
                            </v-col>

                        </v-row>
                    </v-container>
                    <small>*{{$t('referenceBooks.requiredFields')}}</small>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog = false">{{$t('Close')}}</v-btn>
                    <v-btn color="blue darken-1" text @click="attachBranches">{{$t('Pin')}}</v-btn>
                </v-card-actions>
            </v-card>
        </DragForm>
    </div>
</template>

<script>
import Vue from 'vue';
import {notifyError, notifySuccess} from '@/services/notifications';
import DragForm from '@/components/Forms/DragForm.vue';
export default {
  components: {
    DragForm,
  },
  props: {
    branch: {
      type: Object
    }
  },
  data(){
    return {
      selectedBranches: [],
      branches: [],
      dialog: false
    };
  },
  name: 'ChooseBranchesToPinDialog',
  methods: {
    showMessage(title, text, type = ''){
      Vue.notify({
        group: 'notif',
        title: title,
        text: text,
        type: type,
      });
    },
    async attachBranches(){
      const branchToPin = [this.branch.branchId];
      const branchId = this.selectedBranches.branchId;

      await this.$axios.branches.pin(branchId, branchToPin)
        .then(() => {
          notifySuccess('', this.$t('Messages.BranchWasPinnedTo', [this.branch.name, this.selectedBranches.name]));
          this.$emit('pinned', this.branch.branchId);
        })
        .catch(error => {
          notifyError('', this.$t('Error'));
          console.error(error);
        });
    }
  },
  async mounted(){
    await this.$axios.branches.getAvailableBranchesToPin(this.branch.branchId)
      .then(response => response.data)
      .then(json => this.branches = json)
      .catch(error => this.showMessage('Error', error));

  }
};
</script>
